/* CMPND+ hero image lightbox: click/tap a carousel image to view it larger */
(function () {
  if (window.__cmpndZoomReady) return;
  window.__cmpndZoomReady = true;

  var css =
    '.cmpnd-zoom{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:56px 16px 24px;background:rgba(10,10,10,.9);opacity:0;visibility:hidden;transition:opacity .2s ease,visibility .2s ease;-webkit-overflow-scrolling:touch;overflow:auto}' +
    '.cmpnd-zoom.is-open{opacity:1;visibility:visible}' +
    '.cmpnd-zoom img{display:block;max-width:min(96vw,1500px);max-height:calc(100vh - 90px);width:auto;height:auto;object-fit:contain;border-radius:8px;background:#fff;cursor:zoom-in;transition:transform .2s ease}' +
    '.cmpnd-zoom.is-magnified{align-items:flex-start;justify-content:flex-start}' +
    '.cmpnd-zoom.is-magnified img{max-width:none;max-height:none;width:min(220vw,2400px);cursor:zoom-out}' +
    '.cmpnd-zoom-close{position:fixed;top:12px;right:12px;z-index:2;width:44px;height:44px;border:0;border-radius:50%;background:#fff;color:#0f0f0f;font-size:26px;line-height:44px;text-align:center;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.25)}' +
    '.cmpnd-zoom-hint{position:fixed;left:50%;bottom:12px;transform:translateX(-50%);color:#fff;font:500 11px/1.2 "IBM Plex Mono",monospace;letter-spacing:.08em;text-transform:uppercase;opacity:.75;pointer-events:none}' +
    '[data-cmpnd-gallery] .cmpnd-gallery-slide{position:relative}' +
    '[data-cmpnd-gallery] .cmpnd-gallery-slide img{cursor:zoom-in}' +
    '.cmpnd-zoom-badge{position:absolute;right:10px;bottom:10px;z-index:1;display:flex;align-items:center;gap:6px;padding:6px 10px;border-radius:999px;background:rgba(255,255,255,.92);color:#0f0f0f;font:600 10px/1 "IBM Plex Mono",monospace;letter-spacing:.08em;text-transform:uppercase;box-shadow:0 1px 6px rgba(0,0,0,.12);pointer-events:none}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var overlay, bigImg, lastFocus, prevOverflow = '';

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'cmpnd-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Enlarged image');
    overlay.innerHTML =
      '<button type="button" class="cmpnd-zoom-close" aria-label="Close">&times;</button>' +
      '<img alt="">' +
      '<div class="cmpnd-zoom-hint">Tap image to zoom · tap outside to close</div>';
    document.body.appendChild(overlay);
    bigImg = overlay.querySelector('img');

    overlay.addEventListener('click', function (e) {
      if (e.target === bigImg) {
        overlay.classList.toggle('is-magnified');
        return;
      }
      close();
    });
  }

  function largeSrc(img) {
    var src = img.currentSrc || img.src || '';
    return src.replace(/([?&])width=\d+/, '$1width=2400');
  }

  function open(img) {
    if (!overlay) build();
    lastFocus = document.activeElement;
    overlay.classList.remove('is-magnified');
    bigImg.src = largeSrc(img);
    bigImg.alt = img.alt || '';
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    overlay.classList.add('is-open');
    overlay.querySelector('.cmpnd-zoom-close').focus();
  }

  function close() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open', 'is-magnified');
    document.body.style.overflow = prevOverflow;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('[data-cmpnd-gallery] .cmpnd-gallery-slide img');
    if (!img) return;
    e.preventDefault();
    open(img);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  function addBadges() {
    document.querySelectorAll('[data-cmpnd-gallery] .cmpnd-gallery-slide').forEach(function (slide, i) {
      if (i === 0 || slide.querySelector('.cmpnd-zoom-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'cmpnd-zoom-badge';
      badge.innerHTML = '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.6"/><path d="M11 11l3.5 3.5M7 4.5v5M4.5 7h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>Tap to enlarge';
      slide.appendChild(badge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addBadges);
  } else {
    addBadges();
  }
  document.addEventListener('shopify:section:load', addBadges);
})();
